import React from "react";

export default ({ color, size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size || 24} height={size || 24} viewBox="0 0 24 24">
    <path fill={color} d="M14,19H18V5H14M6,19H10V5H6V19Z" />
  </svg>
);
